var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('iframe',{attrs:{"width":"560","height":"315","src":("https://www.youtube.com/embed/" + _vm.id),"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }